export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    //Bulma Responsive Nav
    var burger = document.querySelector('.hamburger');
    var nav = document.querySelector('#' + burger.dataset.target);

    burger.addEventListener('click', function () {
      burger.classList.toggle('is-active');
      nav.classList.toggle('is-active');
    });

    // Magnify button for search
    var magnifyBtn = document.querySelector('.magnify-btn');
    var searchFormContainer = document.querySelector('.search-form-container');
    var searchIcon = document.querySelector('.search-icon');

    // Event listener once magnify icon is clicked
    magnifyBtn.addEventListener('click', function () {
      searchFormContainer.classList.toggle('is-invisible');
      searchFormContainer.classList.toggle('is-hidden');
      searchIcon.classList.toggle('fa-search')
      searchIcon.classList.toggle('fa-close');
    });

    // Search form submit
    var searchField = document.querySelector('.search-field');
    var searchForm = document.querySelector('.search-form');
    var searchSubmitBtn = document.querySelector('.submit-search-btn');

    // Event when enter key hits inside text input
    searchField.onkeydown = function(e){
      if(e.keyCode == 13){
        searchForm.submit();
      }
    };

    // Event when right arrow  is clicked
    searchSubmitBtn.addEventListener('click', function () {
      searchForm.submit();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js